import { useInfoStepAlertContent } from "../../hooks";

export const InfoStepAlert = () => {
  // Datos del hook ----------------------------------------//
  const { title, subTitle } = useInfoStepAlertContent();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <div className="alert bg-soft-success mb-0 p-3" role="alert">
      <h4 className="alert-heading d-inline-block">¡Listo!</h4>
      <button
        type="button"
        className="btn-close float-end"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
      <p className={`${!subTitle && "mb-0"}`}>{title}</p>
      {subTitle && (
        <p className="mb-0 border-top border-success pt-3">{subTitle}</p>
      )}
    </div>
  );
};
